import CustomInput from './CustomInput';

export type { CustomInputProps, CustomInputCssVars } from './CustomInput';

export default CustomInput;
